import React, { useState } from 'react';
import { isValidEmail } from '../utils/membershipHelpers';
import { transferGiftCard } from '../utils/giftCardHelpers';

const GiftCardTransfer = ({ giftCard, currentUserId, onTransferComplete, onCancel }) => {
  const [recipientEmail, setRecipientEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!recipientEmail.trim()) {
      setError('Please enter a recipient email address.');
      return;
    }

    if (!isValidEmail(recipientEmail)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    try {
      await transferGiftCard(giftCard.id, currentUserId, recipientEmail);
      setSuccess(true);
      if (onTransferComplete) {
        setTimeout(() => onTransferComplete(), 2000);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="transfer-modal-overlay">
        <div className="transfer-modal">
          <div className="transfer-success">
            <div className="success-icon">&#10003;</div>
            <h3>Gift Card Transferred!</h3>
            <p>The gift card has been transferred to {recipientEmail}.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="transfer-modal-overlay">
      <div className="transfer-modal">
        <div className="transfer-header">
          <h3>Transfer Gift Card</h3>
          <button className="transfer-close-btn" onClick={onCancel}>&times;</button>
        </div>

        <div className="transfer-card-info">
          <p><strong>{giftCard.coinAmount} tokens ({giftCard.guaranteedPoints} points guaranteed)</strong></p>
        </div>

        <form onSubmit={handleSubmit} className="transfer-form">
          <label className="transfer-label">Recipient Email</label>
          <input
            type="email"
            className="transfer-input"
            placeholder="Enter recipient's email"
            value={recipientEmail}
            onChange={(e) => setRecipientEmail(e.target.value)}
            disabled={loading}
          />

          {error && <div className="transfer-error">{error}</div>}

          <div className="transfer-actions">
            <button type="button" className="transfer-cancel-btn" onClick={onCancel} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="transfer-submit-btn" disabled={loading}>
              {loading ? 'Transferring...' : 'Transfer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GiftCardTransfer;
